import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// ? Import Firebase messaging setup
import { getDeviceToken } from './firebase/firebase';

// ------------------------------
// Register Service Worker
// ------------------------------
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/firebase-messaging-sw.js')
    .then((registration) => {
      console.log('Service Worker registered with scope:', registration.scope);
      
      // After SW is registered, get device token
      getDeviceToken().then(token => {
        if (token) {
          console.log('Device token:', token);
          // Send token to backend
          fetch('/notifications/save-device-token/', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${localStorage.getItem('access')}`
            },
            body: JSON.stringify({ token })
          });
        }
      });

    })
    .catch((err) => {
      console.error('Service Worker registration failed:', err);
    });
}

// ------------------------------
// Render React App
// ------------------------------
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// ------------------------------
// Performance
// ------------------------------
reportWebVitals();
